/* The badge's frame: a label in mono capitals beside a swatch, inside a
 * border of the swatch's colour. The caller names the colour by its fill and
 * border classes, so the frame belongs to no palette - RiskBadge draws a risk
 * step in it from the ramp, Page settings draws On and Off from the signal
 * set. Colour is never the only carrier of state, so a badge always has its
 * label.
 */
import type { ReactNode } from "react";
import s from "./Badge.module.css";

export function Badge({ fill, border, children }: { fill: string; border: string; children: ReactNode }) {
  return (
    <span className={`${s["badge"]} ${border}`}>
      <span className={`swatch ${fill}`} aria-hidden="true" />
      <span className={s["badge__label"]}>{children}</span>
    </span>
  );
}
